import {combineReducers} from 'redux';

import mealSettings from './meal-settings/reducer';
import openingHoursReducer from './opening-hours/reducer';
import manageGroups from './manage-groups/reducer';
import managePlans from './manage-plans/reducer';
import manageRules from './manage-rules/reducer';
import groupMoves from './group-moves/reducer';
import customStatus from './custom-status/reducer';
import kibig from './kibig/reducer';
import genericFunding from './generic-funding/reducer';
import info from './info/reducer';
import parentBooking, {type ParentBookingSettingsState} from './parent-booking/reducer';
import editGroup, {type EditGroupState} from './edit-group/reducer';
import editTag, {type EditTagState} from './edit-tag/reducer';
import {type ManagePlansState} from './manage-plans/types';

export interface InstitutionSettingsState {
    customStatus: any;
    genericFunding: any;
    kibig: any;
    mealSettings: any;
    info: any;
    openingHours: any;
    manageGroups: any;
    manageRules: any;
    groupMoves: any;
    managePlans: ManagePlansState;
    parentBooking: ParentBookingSettingsState;
    editGroup: EditGroupState;
    editTag: EditTagState;
}

export default combineReducers<InstitutionSettingsState>({
    customStatus,
    genericFunding,
    kibig,
    mealSettings,
    info,
    openingHours: openingHoursReducer,
    manageGroups,
    manageRules,
    groupMoves,
    managePlans,
    parentBooking,
    editGroup,
    editTag,
});
